// extracted by mini-css-extract-plugin
export default {"gallery":"c-q_gg","gallery__header":"c-q_gh","gallery__thumbs":"c-q_gi"};